import { render, staticRenderFns } from "./UpdateCodes.vue?vue&type=template&id=5a748d9e"
import script from "./UpdateCodes.vue?vue&type=script&lang=js"
export * from "./UpdateCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports